export default function Footer() {
  return (
    <footer className="footer" data-testid="footer">
      <div className="container">
        <div className="footer__brand">Neuro-Prana Wellness Centre</div>
        <div className="footer__sub">By Dr. Kalpana Randhawa</div>
        <div className="footer__copy">
          © {new Date().getFullYear()} Dr. Kalpana Randhawa · Crafted with care in Jaipur
        </div>
        <div className="footer__credit">Designed and built by Deeptanshu Sharma</div>
      </div>
    </footer>
  );
}
